<template>
  <v-container>
    <v-form ref="form">
      <v-card flat color="grey lighten-3" class="pa-3">
        <v-layout row wrap justify-end>
          <v-flex xs12 sm12 md6>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="blue"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormattedStart"
                  readonly
                  prepend-inner-icon="event"
                  label="วันเริ่มต้น*"
                  solo
                  hide-details
                  v-on="on"
                  color="blue"
                  :rules="nameRules"
                  @blur="date = parseDate(dateFormattedStart)"
                  required
                  ref="startDate_ref"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="th"
                v-model="startDate"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="blue"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormattedEnd"
                  readonly
                  prepend-inner-icon="event"
                  label="วันสิ้นสุด*"
                  solo
                  hide-details
                  v-on="on"
                  color="blue"
                  :rules="nameRules"
                  @blur="date = parseDate(dateFormattedEnd)"
                  required
                  ref="endDate_ref"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="th"
                v-model="endDate"
                no-title
                @input="menu2 = false"
                :min="startDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md12 style="text-align:center">
            <a :href="link !== '' ? link : '#'" style="text-decoration:none">
              <v-btn color="light-green darken-1" @click="queryReport()">
                <v-icon class="mr-1">save_alt</v-icon>
                Download Excel
              </v-btn>
            </a>
            <!-- {{linkCheckPlant}} -->
            <a
              :href="linkCheckPlant !== '' ? linkCheckPlant : '#'"
              style="text-decoration:none"
            >
              <v-btn color="orange lighten-1" @click="queryToken()">
                <v-icon class="mr-1">save_alt</v-icon>
                Download Check Plant
              </v-btn>
            </a>
            <a
              :href="
                linkSumPlantByProvince !== '' ? linkSumPlantByProvince : '#'
              "
              style="text-decoration:none"
            >
              <v-btn color="pink lighten-3" @click="querySumPlantByProvince()">
                <v-icon class="mr-1">save_alt</v-icon>
                Download ชนิดไม้แยกรายจังหวัด
              </v-btn>
            </a>
            <v-btn color="blue lighten-1" @click="queryDataOnePage()">
              <v-icon class="mr-1">save_alt</v-icon>
              Show Data
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
    <v-divider class="mt-3 mb-3"></v-divider>
    <div v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>
    <v-card
      flat
      color="grey lighten-3"
      class="pa-3"
      v-if="listOnePage.length !== 0"
    >
      <v-layout row wrap>
        <v-flex md12 sm12 v-for="(i, index) in listOnePage" :key="index">
          <v-flex md12 sm12>
            <p class="display-1">
              ภาพรวม: ต้นไม้ปลูกไปแล้วทั้งหมด
              {{ commaSeparateNumber(i.allplant) }} ต้น
            </p>
          </v-flex>
          <v-flex md12 sm12 class="title"
            >รายงานวันที่ {{ formatDate(startDate) }} ถึง
            {{ formatDate(endDate) }}
          </v-flex>
          <v-divider class="mt-3 mb-3"></v-divider>
          <v-flex md12 sm12 v-for="(sum, index2) in i.total" :key="index2">
            <v-layout row wrap>
              <v-flex md12 sm12>
                <p class="title">
                  จำนวนต้นไม้ {{ commaSeparateNumber(sum.userPlantSum) }} ต้น
                </p>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 sm12>
                <p class="title">
                  จำนวนผู้ปลูก {{ commaSeparateNumber(sum.numberofpeople) }} ราย
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md12 class="mt-3">
            <v-layout row wrap>
              <v-flex md6 sm12>
                <v-layout row wrap>
                  <v-flex md12 xs12>
                    <p class="title mb-0 font-weight-bold">
                      Top 10 จังหวัดที่ปลูกสูงสุด
                    </p>
                  </v-flex>
                  <v-flex md12 sm12>
                    <table>
                      <tr>
                        <td></td>
                        <td width="100px" style="text-align:right">ราย</td>
                        <td width="100px" style="text-align:right">ต้น</td>
                      </tr>
                      <tr
                        v-for="(top10, index3) in i.top10Province"
                        :key="index3"
                      >
                        <td width="200px" style="text-align:left">
                          <p class="title">{{ top10.province_name }}</p>
                        </td>
                        <td width="100px" style="text-align:right">
                          <p class="title">
                            {{ commaSeparateNumber(top10.numberofpeople) }}
                          </p>
                        </td>
                        <td width="100px" style="text-align:right">
                          <p class="title">
                            {{ commaSeparateNumber(top10.sumPlantByProvince) }}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md6 sm12>
                <v-layout row wrap>
                  <v-flex md12 sm12>
                    <p class="title mb-0 font-weight-bold">
                      Top 10 ชนิดต้นไม้ปลูกสูงสุด
                    </p>
                  </v-flex>
                  <v-flex md12 sm12>
                    <table>
                      <tr>
                        <td></td>
                        <td width="100px" style="text-align:right">ต้น</td>
                      </tr>
                      <tr
                        v-for="(top10Plant, index4) in i.top10Plant"
                        :key="index4"
                      >
                        <td width="200px" style="text-align:left">
                          <p class="title">
                            {{ top10Plant.plant_name }}
                          </p>
                        </td>
                        <td width="100px" style="text-align:right">
                          <p class="title">
                            {{ commaSeparateNumber(top10Plant.sumPlant) }}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider class="mt-3 mb-3"></v-divider>
    <v-card flat color="grey lighten-3" class="pa-3">
      <v-layout justify-end>
        <v-flex xs12 sm12 md5 d-flex offset-md7>
          <v-text-field
            label="User Plant ID"
            prepend-inner-icon="info"
            solo
            hide-details
            color="blue"
            v-model="user_plant_id"
            @keyup.enter="queryInformationUser()"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md2>
          <v-btn color="primary" @click="queryInformationUser()">
            <v-icon class="mr-1">search</v-icon>
            ค้นหา
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table :headers="headers" :items="listUser" class="mt-3">
        <template v-slot:items="props">
          <td>{{ props.item.user_plant_id }}</td>
          <td class="text-xs-left">{{ props.item.title }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.surname }}</td>
          <td class="text-xs-left">{{ props.item.phone }}</td>
          <td class="text-xs-left">{{ props.item.latitude }}</td>
          <td class="text-xs-left">{{ props.item.longitude }}</td>
          <td class="text-xs-left">{{ props.item.plant_name }}</td>
          <td class="text-xs-left">{{ props.item.amount }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { log } from "util";
import moment from "moment";
export default {
  data() {
    return {
      isLoading: false,
      dateFormattedStart: "",
      dateFormattedEnd: "",
      startDate: "",
      endDate: "",
      menu: false,
      menu2: false,
      headers: [
        {
          text: "user_plant_id",
          align: "left",
          sortable: true,
          value: "user_plant_id"
        },
        { text: "คำนำหน้าชื่อ", align: "left", value: "title" },
        { text: "ชื่อ", value: "name" },
        { text: "นามสกุล", value: "surname" },
        { text: "โทรศัพท์", value: "phone" },
        { text: "ละติจูด", value: "latitude" },
        { text: "ลองจิจูด", value: "longitude" },
        { text: "ชนิดไม้", value: "plant_name" },
        { text: "จำนวน", value: "amount" }
      ],
      listUser: [],
      items: [
        { name: "ชนิดไม้รายคน", value: "user" },
        { name: "ชนิดไม้รายจังหวัด", value: "province" }
      ],
      user_plant_id: "",
      link: "",
      linkCheckPlant: "",
      linkSumPlantByProvince: "",
      nameRules: [(v) => !!v || "Name is required"],
      listOnePage: []
    };
  },
  watch: {
    startDate() {
      this.dateFormattedStart = this.formatDate(this.startDate);
    },
    endDate() {
      this.dateFormattedEnd = this.formatDate(this.endDate);
    }
  },
  created() {},
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}/${month}/${year_thai}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      var year_2 = parseInt(year) - 543;
      return `${year_2}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    queryReport() {
      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }
      this.link =
        process.env.VUE_APP_IPFLASK +
        "/getFile/report/" +
        this.startDate +
        "_" +
        this.endDate +
        "_" +
        moment().format("H:mm:ss") +
        ".xlsx";
      // this.link = process.env.VUE_APP_IPFLASK + "/getFile/report/" + this.startDate + "_" + this.endDate + ".xlsx";
    },
    querySumPlantByProvince() {
      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }

      this.linkSumPlantByProvince =
        process.env.VUE_APP_IPFLASK +
        "/getFileSumPlant/report/" +
        this.startDate +
        "_" +
        this.endDate +
        "_" +
        moment().format("DDMMY:H:mm:ss") +
        ".xlsx";
      // this.link = process.env.VUE_APP_IPFLASK + "/getFile/report/" + this.startDate + "_" + this.endDate + ".xlsx";
    },
    queryToken() {
      // console.log(moment().format("H:mm:ss"));

      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }

      this.axios
        .get(
          process.env.VUE_APP_IPFLASK +
            "/getFileCheckPlant/report/" +
            "checkPlant_" +
            this.startDate +
            "_" +
            this.endDate +
            "_" +
            moment().format("H:mm:ss") +
            ".xlsx"
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data === "no data") {
            this.$swal("ไม่พบข้อมูลวันที่ท่านเลือก", "", "error");
          } else {
            // this.linkCheckPlant =
            //   process.env.VUE_APP_IPFLASK +
            //   "/getFileCheckPlant/report/" +
            //   "checkPlant_" +
            //   this.startDate +
            //   "_" +
            //   this.endDate +
            //   "_" +
            //   moment().format("H:mm:ss") +
            //   ".xlsx";
            this.linkCheckPlant =
              "https://plant.forest.go.th" +
              "/getFileCheckPlant/report/" +
              "checkPlant_" +
              this.startDate +
              "_" +
              this.endDate +
              "_" +
              moment().format("H:mm:ss") +
              ".xlsx";

            // this.$refs.linkCheckPlant.click()
            window.location = this.linkCheckPlant;
          }
        });
    },
    commaSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    queryDataOnePage() {
      this.isLoading = true;
      this.listOnePage = [];
      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }

      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryDataOnePage", {
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data === "no data") {
            this.isLoading = false;
            this.$swal("ไม่พบข้อมูลวันที่ท่านเลือก", "", "error");
          } else {
            this.isLoading = false;
            this.listOnePage = response.data;
            // console.log(response);
          }
        });
    },
    queryInformationUser() {
      if (this.user_plant_id === "") {
        this.$swal("กรุณากรอกรหัส User Plant ID", "", "error");
      } else {
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/queryInformationUser", {
            user_plant_id: this.user_plant_id
          })
          .then((response) => {
            // console.log(response.data);
            this.listUser = response.data;
            this.user_plant_id = "";
          });
      }
    }
  }
};
</script>
